import React, { memo, useCallback, useEffect } from 'react';
import PropTypes from 'prop-types';
import { Col, Row } from 'react-grid-system';
import { HighlightTableWrapper, HighlightTableMessage } from './styles';
import Label from '../shared/Label';
import CompetitionTable from '../../containers/HubLive/SportTable/CompetitionTable';
import PromoHighlighted from '../PromoHighlighted';

const isEmptyList = (competitions) => {
  if (competitions && competitions.size > 0) {
    for (const currentSport of competitions.keySeq().toArray()) {
      if (competitions.get(currentSport) && competitions.get(currentSport).size > 0) {
        return false;
      }
    }
  }
  return true;
};

const HighlightTable = ({
  competitions,
  sportName,
  actions,
  dictionary,
  isMobile,
  filterDate,
  isHighlight,
  promohighlighted,
}) => {
  const renderCompetition = (currentSport) => (currentCompetition, indexComp) => {
    const hasMatches = currentCompetition.get('competitionMatches') && currentCompetition.get('competitionMatches').size > 0;
    return hasMatches &&
    <Row key={indexComp} style={{ margin: '0px' }}>
      <Col md={12} sm={12} xs={12} style={{ padding: '0px' }}>
        <CompetitionTable
          actions={actions}
          showRowScorer={false}
          competition={currentCompetition}
          sportName={sportName}
          key={indexComp}
          dictionary={dictionary}
          sportId={currentSport}
          isMobile={isMobile}
          date={filterDate.get('value')}
          isHighlight={isHighlight}
          isRace={(currentSport === '6M' || currentSport === '6C')}
        />
      </Col>
    </Row>
  };

  const renderCompetitions = (currentSportId) => {
    // currentSportId may be of values [1: Calcio, 3: Basket, 8: Tennis]
    // Render a list of competitions for each sport
    return competitions.get(currentSportId).map(renderCompetition(currentSportId))
  };

  return (
    (promohighlighted && promohighlighted.size > 0) || !isEmptyList(competitions) ?
      (
        <HighlightTableWrapper>
          <HighlightTableMessage>
            <Label
              color="white"
              label="Da non perdere"
              size={1.1}
              isTitleNarrowMedium
            />
          </HighlightTableMessage>

          {promohighlighted && promohighlighted.size > 0 && 
            <PromoHighlighted promohighlighted={promohighlighted} isMobile={isMobile} />
          }

          {
            competitions && competitions.size > 0 && competitions.keySeq().toArray().map(renderCompetitions)
          }
        </HighlightTableWrapper>
      ) : <div />
  )
};

HighlightTable.propTypes = {
  dictionary: PropTypes.any,
  competitions: PropTypes.any,
  sportName: PropTypes.any,
  actions: PropTypes.any,
  isMobile: PropTypes.any,
  filterDate: PropTypes.any,
  isHighlight: PropTypes.bool,
  promohighlighted: PropTypes.any,
};

export default HighlightTable;
